import { UserRolesEnum } from "../../pages/auth/userRoles.enum";

// Webinars & events listing on the public website.
export const LIVE_TRAINING_URL = "https://kapsurvey.com/resources/webinar-and-event";

// Mirrors the ProtectedRoute guard on /tickets in src/app/Routes.js — a role
// must not see a link it cannot open without landing on /unauthorized.
export const TICKETS_ROLES = [
   UserRolesEnum.SuperAdmin,
   UserRolesEnum.Organization,
   UserRolesEnum.AdminOfOrganization,
   UserRolesEnum.SeniorProjectManager,
   UserRolesEnum.JuniorProjectManager,
   UserRolesEnum.ProjectManager,
   UserRolesEnum.Guest
];

/**
 * Video Library: videos and interactive demos. Entries show in the order
 * listed, grouped by `category`. While this is empty the Help Center still
 * lists the library, as "Coming soon" and not clickable; the first entry here
 * makes it open.
 *
 * {
 *    id: "create-a-survey",                 // unique and stable
 *    title: "Create a survey",
 *    description: "Build a survey from scratch and publish it.",   // optional
 *    category: "Getting started",           // optional
 *    duration: "3:45",                      // optional
 *    url: "https://youtu.be/...",           // YouTube, Vimeo, Loom, a Storylane demo
 *                                           // (app.storylane.io/share/...), or a direct .mp4/.webm file
 *    thumbnail: "https://..."               // optional, YouTube thumbnails are picked up on their own
 * }
 */
export const HELP_VIDEOS = [];

/**
 * Questions Ask AI suggests before the first one, in this order. Each names
 * the article that answers it; users who can't see that article don't get
 * the question.
 */
export const ASK_SUGGESTIONS = [
   { question: "How do I publish and share a survey?", article: "publish-and-share" },
   { question: "How do I show a question only when it applies?", article: "survey-logic" },
   { question: "How do I import a survey from Excel?", article: "import-survey" },
   { question: "How do I add members to my organization?", article: "organization-members" },
   { question: "Where do I find the surveys assigned to me?", article: "my-tasks" },
   { question: "Can I fill in a survey without internet?", article: "collect-offline" },
   { question: "How do I contact support?", article: "support-tickets" }
];
